import(/* webpackMode: "eager" */ "/vercel/path0/rosetai/app/contact/page.js");
